export function NavBar() {
    return <nav className="navbar navbar-expand-lg navbar-light bg-light"><div className="container-fluid">
        <a className="navbar-brand">Dashboard</a>

    </div></nav>

}